var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.187 8.39C19.014 7.745 18.506 7.236 17.861 7.064C16.691 6.75 12 6.75 12 6.75C12 6.75 7.309 6.75 6.14 7.063C5.494 7.236 4.986 7.744 4.813 8.39C4.5 9.559 4.5 12 4.5 12C4.5 12 4.5 14.441 4.813 15.61C4.986 16.255 5.494 16.764 6.139 16.936C7.309 17.25 12 17.25 12 17.25C12 17.25 16.691 17.25 17.86 16.937C18.505 16.765 19.014 16.256 19.186 15.611C19.5 14.441 19.5 12 19.5 12C19.5 12 19.5 9.559 19.187 8.39ZM10.5 14.25V9.75L14.397 12L10.5 14.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1c3c45d58cd8ff780a3656a98975911d.svg";
export { ForwardRef as ReactComponent };